import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors, layout, bp } from '../../theme'

const Main = styled.footer`
  width: 100%;
  margin-top: auto;
  background: ${colors.white};
  border-top: 1px solid ${colors.line};
  color: ${colors.slate};
`

const Container = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
  padding: 3rem 1.5rem 1.5rem;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 2rem;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: 1fr;
    text-align: left;
  }
`

const Section = styled.div`
  h3 {
    margin: 0 0 0.9rem;
    color: ${colors.green};
    font-size: 1rem;
  }

  p {
    margin: 0 0 0.5rem;
    font-size: 0.92rem;
    line-height: 1.6;
  }

  a {
    font-size: 0.92rem;
    color: ${colors.slate};
    text-decoration: none;
    line-height: 1.6;
    display: block;
  }

  a:hover {
    color: ${colors.green};
  }
`

const Brand = styled.div`
  h3 {
    color: ${colors.green};
    margin: 0 0 0.3rem;
    font-size: 1.15rem;
    font-weight: 800;
  }

  .tag {
    color: ${colors.red};
    font-weight: 700;
    letter-spacing: 0.5px;
    font-size: 0.8rem;
    margin-bottom: 0.75rem;
  }

  p {
    font-size: 0.92rem;
    line-height: 1.6;
    max-width: 26rem;
  }
`

const Bottom = styled.div`
  max-width: ${layout.maxWidth};
  margin: auto;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid ${colors.line};
  text-align: center;
  font-size: 0.83rem;
  color: ${colors.slate};
`

const Footer = () => (
  <Main>
    <Container>
      <Brand>
        <h3>DESPAR CLEAN</h3>
        <div className="tag">CLEAN. STERILE. TRUSTED.</div>
        <p>
          Desparclean Sterix Holdings Limited manufactures, retails, and supplies
          high-performance detergents and the NBIoT EcoSmart Dispenser — from our Nairobi
          hub to customers nationwide.
        </p>
      </Brand>

      <Section>
        <h3>Explore</h3>
        <a href="#products">Product Range</a>
        <a href="#dispenser">Smart Dispenser</a>
        <a href="#who-we-serve">Who We Serve</a>
        <a href="#impact">Climate Impact</a>
        <Link to="/login">Dashboard Login</Link>
      </Section>

      <Section>
        <h3>Contact</h3>
        <p>KSD Business Park, Embakasi, Nairobi</p>
        <a href="mailto:info@desparclean.com">info@desparclean.com</a>
        <p>0723 437 122 · 0729 230 330</p>
        <p>www.desparclean.com</p>
      </Section>
    </Container>

    <Bottom>
      © {new Date().getFullYear()} Desparclean Sterix Holdings Limited. All rights reserved.
    </Bottom>
  </Main>
)

export default Footer
